import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Link from 'next/link';

export default class index extends Component {
    render() {
        return (
            <section className="devalopement-sec">
                <Container>
                    <div className="mt-sm-4 mb-4 pt-4 pb-sm-4">
                        <Row>
                        <Col className="text-center mobile">
                                <ScrollAnimation animation='bounceInRight'>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/marketing-sec.png`} alt="marketing-sec" className="mt-3 auto-width-c" />
                                </ScrollAnimation>
                            </Col>
                            <Col className="pr-sm-0" md>
                                <ScrollAnimation animation='bounceInLeft'>
                                    <div className="pl-sm-3">
                                        <div className="mt-4 pt-4">
                                            <div className="count">04</div>
                                            <div className="talk-content count-sd pl-3">What we do?</div>
                                        </div>
                                        <div className="main-heading-home pt-sm-2">Branding and Digital Marketing</div>
                                        <div className="main-content pt-sm-1">
                                                 Marketing is not about making a sale. It is about narrating your story, making relationships and building trust.
                                             </div>
                                        {/* <div className="main-content">
                                            doubling your conversion rate than by doubling your traffic.
                                            </div> */}
                                        <Link href="/branding-services" as="/Branding-and-Digital-Marketing">
                                            <div className="talk-content explore mt-sm-5">Explore
                                               <img src={`${publicRuntimeConfig.staticFolder}/images/Path.svg`} alt="Path" className="ml-sm-1" />
                                            </div>
                                        </Link>
                                    </div>
                                </ScrollAnimation>
                            </Col>
                            <Col className="text-center desktop">
                                <ScrollAnimation animation='bounceInRight'>
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/marketing-sec.png`} alt="marketing-sec" className="mt-3 auto-width-c" />
                                </ScrollAnimation>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <style>
                    {
                        `
                        body{
                            overflow-x: hidden
                        }
                        `
                    }
                </style>
            </section>
        )
    }
}
